import { IAuthState } from '@/types/app';
import { ACCESS_TOKEN_NAME } from '@/const';
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import { IUser } from '@/types/models';

function getToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_NAME);
}

function setToken(token: string) {
  localStorage.removeItem(ACCESS_TOKEN_NAME);
  localStorage.setItem(ACCESS_TOKEN_NAME, token);
}

function removeToken() {
  localStorage.removeItem(ACCESS_TOKEN_NAME);
}

@Module({ namespaced: true, name: 'auth' })
export default class Auth extends VuexModule implements IAuthState {
  public token = getToken();

  get mobile(): string {
    return this.user.mobile;
  }

  public user: IUser = {} as IUser;

  @Mutation
  private SET_TOKEN(token: string) {
    this.token = token;
  }

  @Mutation
  private SET_USER(user: IUser) {
    this.user = user;
  }

  @Action
  login(token: string, user: IUser) {
    this.SET_TOKEN(token);
    this.SET_USER(user);
    setToken(token);
  }

  @Action
  setUser(user: IUser) {
    this.SET_USER(user);
  }

  @Action
  logout() {
    this.SET_TOKEN('');
    removeToken();
  }
}
